<div [innerHTML]="url" id="iframe-holder" class="sm:tw-max-h-[500px] sm:tw-min-h-[500px] tw-max-h-[300px] tw-min-h-[300px]
   lg:tw-max-w-[1000px] lg:tw-min-w-[1000px] md:tw-max-w-[500px] md:tw-min-w-[500px]
   tw-max-w-[300px] tw-min-w-[300px]">
</div>
<!-- form btns-->
<section class="">
  <div class="tw-flex tw-justify-end">
    <div class="tw-flex tw-justify-end tw-h-[70%] tw-w-full" style="max-width: 275px;">
      <!-- cancel btn -->
      <a mat-ripple class="btn tw-ml-[5px] ltr:tw-mr-[5px] tw-w-1/2  button-shadow tw-h-[70%] btn-danger" (click)="onClose()">
        {{'common.back'|translate}}
      </a>
    </div>
  </div>
</section>
